<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -extra-width"
       [ngClass]="{'-is-open': tixxSelectOverviewService.listOfModals.editSpecialRequirementModalOpened}">
  <div class="esf-main-sidebar__content">
    <h3 i18n="general.heading.optionalCheckbox">Optional Checkbox</h3>
    <form [formGroup]="optionalCheckboxForm" (ngSubmit)="submitForm()" id="optionalCheckboxForm">
      <div app-form-field-select
           [control]="optionalCheckboxForm.get('specialRequirement')"
           [label]="flTranslations.i18nOptionalCheckbox"
           [useNgValue]="true"
           [array]="yesOrNoDropdown">
      </div>
      <div app-form-field-text-generic
           [optional]="true"
           [control]="optionalCheckboxForm.get('event.specialRequirementDescription')"
           [placeholder]="flTranslations.i18nOptionalCheckboxText"
           [label]="flTranslations.i18nOptionalCheckboxText">
      </div>
      <div app-form-field-rich-text
           [optional]="true"
           [quillModules]="quillModules"
           [control]="optionalCheckboxForm.get('event.specialRequirementText')"
           [label]="flTranslations.i18nOptionalCheckboxDescription"
           [placeholder]="flTranslations.i18nOptionalCheckboxDescription">
      </div>
    </form>

  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -extra-width"
     [ngClass]="{'-is-open': tixxSelectOverviewService.listOfModals.editSpecialRequirementModalOpened}">
  <app-submit-row-buttons [form]="'optionalCheckboxForm'"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="tixxSelectOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space -has-transition"
     [ngClass]="{'-is-open': tixxSelectOverviewService.listOfModals.editSpecialRequirementModalOpened }" (click)="tixxSelectOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
